<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5" shaped>
            <v-row dense>
              <v-col cols="12">
                <strong>AAM - ADJUST INCENTIVE APPROVAL</strong>
              </v-col>
            </v-row>
            <hr />
            <!-- <v-row class="mt-4">              
              <v-col cols="6" md="3">
                <v-text-field
                  color="red darken-1"
                  v-model="invoiceNo"
                  label="Invoice Number"
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="3">
                 <v-btn
                  @click="filterDataTable"
                  outlined
                  color="indigo lighten-1"
                  :disabled="dtLoading"
                  >Load List</v-btn>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col cols="6">
                <v-card class="pa-2">
                  <v-row dense>
                    <v-col cols="3" align-self="center">PERIOD</v-col>
                    <v-col cols="9">
                      <v-menu
                        v-model="openPeriod"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                          color="red darken-1"
                            v-model="period"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="period" type="month" @input="openPeriod = false" color="red darken-1"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="3"></v-col>
                    <v-col cols="9">
                      <v-btn @click="filterDataTable" color="warning" block>FIND</v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card class="pa-3" outlined>
                  <v-card-title>
                    <v-text-field
                      color="red darken-1"
                      v-model="searchRole"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    v-model="selected"
                    :headers="dtHeaders"
                    :items="dtItems"
                    :search="searchRole"
                    :loading="dtLoading"
                    loading-text="Fetching Data..."
                    dense
                    show-select
                    single-expand
                    @click:row="handleClick"
                    class="elevation-1"
                    item-key="ADJUST_ID"
                    
                  >
                  </v-data-table>
                  <div class="d-flex justify-center">                    
                    <v-btn @click="reject" small class="mx-1" color="error"
                      >REJECT</v-btn
                    >
                    <v-btn @click="approve" small class="mx-1" color="warning"
                      >APPROVE</v-btn
                    >
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";
import XLSX from "xlsx";

const dtHeaders = [
  {
    text: "Branch",
    value: "BRANCH_CODE",
  },
  {
    text: "Customer Name",
    value: "CUSTOMER_NAME",
  },
  {
    text: "Invoice Number",
    value: "INVOICE_NUMBER",
  },
  {
    text: "Invoice Period",
    value: "INVOICE_PERIODE",
  },
  {
    text: "Product Name",
    value: "PRODUCT_NAME",
  },
  {
    text: "Product Desc",
    value: "PRODUCT_DESC",
  },
  {
    text: "Position From",
    value: "POSITION_FROM",
  },
  {
    text: "Position To",
    value: "POSITION_TO",
  },
  {
    text: "Value Adjust",
    value: "VALUE_ADJUST",
  },
  {
    text: "Notes",
    value: "NOTES",
  },
  {
    text: "Status",
    value: "STATUS",
  }
];

export default {
  components: {
    Main,
  },
  data() {
    return {
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      branchList: [],
      branch: null,
      searchRole: "",
      dtLoading: false,
      dtHeaders,
      dtItems: [],
      position: "",
      selected: [],
      invoiceNo: "",
      openPeriod: false,
      orgID :JSON.parse(localStorage.getItem('userData')).ORG_ID,
     period: moment().format("YYYY-MM"),
      userIdUpdate: JSON.parse(localStorage.getItem('userData')).USER_ID
    };
  },
  mounted() {
    console.log('test ', JSON.parse(localStorage.getItem('userData')));
  },
  methods: {
    filterDataTable() {
      this.dtLoading = true;
      const splitPeriod = this.period.split("-");
      const month = splitPeriod[1];
      const year = splitPeriod[0];
      const orgID = this.orgID;
      const data = {
        month,
        year,
        orgID
      };
      console.log('data ', data);
      this.$http
        .post("/adjust-incentive/getMappingAdjustIncentive", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {console.log('res ', res.data);
          // if (!res.data.success || res.data.success == undefined) {
          //   console.log(res);
          // }
          let { data } = res.data;
          if (data.length <= 0) {
            this.dtLoading = false;
            this.dtItems = [];
          }
          data.forEach((obj, index) => {
            data[index].INVOICE_PERIODE = moment(data[index].INVOICE_PERIODE).format(
              "YYYY-MM-DD"
            );
            data[index].USERID_UPDATE = this.userIdUpdate;
          });
          this.dtLoading = false;
          this.dtItems = data;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
    handleClick(value)
    {
      console.log('valcheck ',value)
    },
    approve() { 
       if (confirm(" Apakah Yakin akan lakukan Approve?")) {
          this.isLoading = true;
          this.$http
            .post('/adjust-incentive/approve', this.selected, {
              headers: {
                "api-key": this.$apiKey
              }
            })
            .then((res) => {
              this.isLoading = false;
              const data = res.data;
              if (data.success) {
                this.showSnackbar('Success..');
                this.selected = [];
                this.filterDataTable();
              } else {
                this.showSnackbar('Something is wrong..');
              }
            })
            .catch((err) => {
              this.isLoading = false;
              this.showSnackbar(err.toString());
            });
       }
			
		},
    reject() {
      if (confirm(" Apakah Yakin akan lakukan Reject?")) {
          this.isLoading = true;
          this.$http
            .post('/adjust-incentive/reject', this.selected, {
              headers: {
                "api-key": this.$apiKey
              }
            })
            .then((res) => {
              this.isLoading = false;
              const data = res.data;
              if (data.success) {
                this.showSnackbar('Success..');
                this.selected = [];
                this.filterDataTable();
              } else {
                this.showSnackbar('Something is wrong..');
              }
            })
            .catch((err) => {
              this.isLoading = false;
              this.showSnackbar(err.toString());
            });
      }			
		},
  },
};
</script>
